import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import DeveloperNavigator from "../../../navigation/DeveloperNavigator";
import styles from "./developer.module.css";

const Developer = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("developer", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/developer/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <DeveloperNavigator />
    </div>
  );
};

export default Developer;
